
import gallerySwiperVue from '@/components/gallerySwiper.vue';
import comment from '@/components/comment.vue';
import sideInfo from '@/components/gallery/sideInfo.vue'
import BlockUserDialog from '@/components/block/BlockUserDialog.vue'
import UnblockUserDialog from '@/components/block/UnblockUserDialog.vue'
import BlockedEmptyState from '@/components/block/BlockedEmptyState.vue'
import noContent from '@/components/noContent.vue'
import blockUserMixin from '@/mixins/blockUser'
import {
    BLOCK_ENTRY_POINT,
    getBlockedAuthorFromDetailRes,
    isBlockInteractForbidden,
    isBlockedContentHiddenByOther,
    isContentSealedOrPrivate,
} from '@/utils/blockUser'
import { canAuthorEditContent } from '@/utils/contentEdit'

export default {
    components: {
        gallerySwiperVue,
        comment,
        sideInfo,
        BlockUserDialog,
        UnblockUserDialog,
        BlockedEmptyState,
        noContent,
    },
    mixins: [blockUserMixin],
    name: 'index',
    head() {
        // 优化seo：动态设置title，keywords 和 description
        //  property: "og:xxxx" 是facebook分享 图谱抓取的内容
        //  name="twitter:site" twitter  图谱抓取的内容
        //fackbook分享调试器 https://developers.facebook.com/tools/debug/
        if (this.isBlockedContent || this.isEmptyContent) {
            return { title: 'XPPen Community' }
        }
        return {
            title: this.source.seoTiltle,
            meta: [
                {
                    name: "keywords",
                    content: "xppen-xfans-community-workDetails",
                },
                {
                    property: "og:title",
                    content: this.source.title,

                },
                {
                    property: "og:image",
                    content: this.source.face_url,

                },
                {
                    property: "og:description",
                    content: this.source.content,
                },
                {
                    property: "og:type",
                    content: 'website',
                },
                {
                    name: "twitter:card",
                    content: 'summary_large_image'
                },
                {
                    name: "twitter:site",
                    content: '@XPPEN'
                },
                {
                    name: "twitter:title",
                    content: 'XPPen Community',
                },
                {
                    name: "twitter:description",
                    content: this.source.content,
                },

                {
                    name: "twitter:image",
                    // content: 'https://cdn.cms-twdigitalassets.com/content/dam/developer-twitter/redesign-2021-images/og-social-card/devwebsite_card_tn.jpg.twimg.768.jpg'
                    content: this.source.works_images && this.source.works_images.length != 0 ? this.source.works_images[0].thumb : this.source.thumb_video,
                },
                {
                    name: 'description', content: this.source.content,
                },
            ],
        };
    },
    data() {
        return {
            source: {},
            followLoading: false,
            isBlockedContent: false, // 详情因拉黑关系不可见
            isEmptyContent: false, // 审核未公开 / 接口失败时页内暂无内容，不走 404/500
            blockEmptyVariant: 'blocker', // blocker=拉黑者空态；hidden=被拉黑者空态
            blockTargetUserId: null,
            blockNickname: '',
            blockAvatar: '',
        };
    },
    async asyncData({ $global, params }) {
        /** 审核未公开或接口失败：页内暂无内容，禁止 error(404/500) */
        const buildEmptyState = () => ({
            isEmptyContent: true,
            isBlockedContent: false,
            source: { works_images: [] },
            isAtlas: true,
            playerOptions: {},
        })
        /** 拉黑不可见时返回空态所需字段，避免 error(500) */
        const buildBlockedState = (res) => {
            const hiddenByOther = isBlockedContentHiddenByOther(res)
            const author = getBlockedAuthorFromDetailRes(res)
            return {
                isBlockedContent: true,
                blockEmptyVariant: hiddenByOther ? 'hidden' : 'blocker',
                // 被拉黑者不能移出对方黑名单，不传目标用户
                blockTargetUserId: hiddenByOther ? null : author.target_user_id,
                blockNickname: author.nickname,
                blockAvatar: author.avatar,
                source: {
                    uid: author.target_user_id,
                    nickname: author.nickname,
                    works_images: [],
                },
                isAtlas: true,
                playerOptions: {},
            }
        }
        try {
            const res = await $global.worksDetails({ id: params.id })
            if (isBlockInteractForbidden(res)) {
                return buildBlockedState(res)
            }
            if (isContentSealedOrPrivate(res)) {
                return buildEmptyState()
            }
            if (res.code == 200) {
                if (!res.data || !res.data.hasOwnProperty('id')) {
                    return buildEmptyState()
                }
                const isAtlas = res.data.works_images?.length == 0 ? false : true
                let playerOptions = {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [
                        { type: 'video/mp4', src: res.data.thumb }
                    ],
                    poster: res.data.thumb_video, //你的封面地址
                    width: '100%',
                    notSupportedMessage: 'This video is currently unavailable, please try again later', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                }
                res.data.seoTiltle = res.data.content
                let code = '' + (parseInt(Math.random() * 10000000) + 10000000);
                code = code.substring(1, 9);
                res.data.works_images.length != 0 ? res.data.works_images[0].thumb = `${res.data.works_images[0].thumb}?random=${code}` : ''

                return { source: res.data, isAtlas, playerOptions, isBlockedContent: false, isEmptyContent: false }
            }
            return buildEmptyState()
        } catch (e) {
            const body = e && e.response && e.response.data
            if (isBlockInteractForbidden(body)) {
                return buildBlockedState(body)
            }
            if (isContentSealedOrPrivate(body)) {
                return buildEmptyState()
            }
            return buildEmptyState()
        }
    },
    mounted() {
        if (this.isBlockedContent || this.isEmptyContent) return
        if (Array.isArray(this.source.appoint_uid)) {
            //将内容中@xxx替换成链接
            this.source.appoint_uid.forEach(it => {
                if (this.source.content.includes(it.nickname)) {

                    this.source.content = this.source.content.replaceAll(it.nickname, `<a href="/user/${it.uid}" style="color:#f9874f">${it.nickname}</a>`)
                }
            })
        }
        /** hwtag埋点-阅读*/
        this.$track('content_viewed', {
            'content_id': this.source.id,
            'content_type': 'gallery',
            'author_id': this.source.uid,
            'author':this.source.nickname,
            'current_view':this.source.hits
        });

    },
    methods: {
        async galleryDetails() {
            //获取详情数据
            const result = await this.$global.worksDetails({ id: this.$route.params.id })
            this.source = result.data
        },

        /** 作品详情拉黑入口，来源只传 works；成功后留在当前页并隐藏更多操作，刷新才走空态 */
        async onClickBlockUser() {
            try {
                await this.openBlockDialog({
                    target_user_id: this.source.uid,
                    entry_point: BLOCK_ENTRY_POINT.WORKS,
                    nickname: this.source.nickname,
                    avatar: this.source.user_thumb_face_url || this.source.user_thumb_compress || this.source.face_url,
                })
                this.$set(this.source, 'is_blocked_by_me', 1)
            } catch (e) {
                // 取消、未登录或参数非法时不改页面状态
            }
        },
        goBlacklistSettings() {
            this.$router.push({ path: '/setup/blacklist' })
        },
        /** 详情拉黑空态移出黑名单后刷新以恢复内容 */
        async onClickUnblockUser() {
            if (!this.blockTargetUserId) {
                this.goBlacklistSettings()
                return
            }
            try {
                await this.openUnblockDialog({
                    target_user_id: this.blockTargetUserId,
                    nickname: this.blockNickname,
                    avatar: this.blockAvatar,
                })
                if (process.client) {
                    window.location.reload()
                }
            } catch (e) {
                // 取消或失败保持空态
            }
        },
        /** 进入现有作品发布页，带上作品 id 预填并走编辑提交 */
        goEditWork() {
            const type = this.isAtlas ? 1 : 2
            this.$router.push({
                path: '/releaseWork',
                query: { id: this.source.id, type },
            })
        },
        async deleteWorks(works_id) {
            //删除作品
            let res = await this.$global.worksDel({ works_id, })
            res.code == 200 ? this.$message({
                message: res.msg,
                type: 'success'
            }) : ''
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000)

        },
        onPlayerPlay(player) { },
        onPlayerPause(player) { }

    },
    computed: {
        player() {
            return this.$refs.videoPlayer && this.$refs.videoPlayer.player
        },
        /** 登录用户 id。刷新后 Vuex 从本地恢复，不能在 created 里抄一份 */
        currentUid() {
            return this.$store.state.userInfo?.userInfo?.uid || ''
        },
        /** 当前登录用户就是作者。空 id 不算自己，避免刷新后误显示拉黑/举报 */
        isOwnContent() {
            const mine = Number(this.currentUid)
            const author = Number(this.source && this.source.uid)
            return mine > 0 && mine === author
        },
        /** 看自己的详情时，有 edit_status 优先显示修改审核；没有该字段仍按 status。其他人看详情不显示修改审核 */
        reviewLabel() {
            const source = this.source || {}
            const editStatus = source.edit_status
            const hasEditStatus = editStatus !== undefined && editStatus !== null
            if (hasEditStatus) {
                if (!this.isOwnContent) return ''
                if (editStatus === 0) return this.$t('page.EDIT_CONTENT_PENDING')
                if (editStatus === -3) return this.$t('page.EDIT_CONTENT_REJECTED')
                return ''
            }
            if (source.status == 0) return '! The work is under review'
            if (source.status == -1) return 'deleted'
            if (source.status == -2) return 'Audit not passed'
            return ''
        },
        /** 作者且未删除时可编辑；删除态只保留删除 */
        canEditContent() {
            return this.isOwnContent && canAuthorEditContent(this.source.status)
        },
        /** 自己的作品保留删除；对方作品若已拉黑则隐藏更多按钮 */
        showDetailActions() {
            if (this.isBlockedContent || this.isEmptyContent) return false
            if (this.isOwnContent) return true
            return this.source.is_blocked_by_me !== 1
        },
        /** 浏览器手机模式没有悬停，改为点击；桌面仍悬停 */
        menuTrigger() {
            if (!process.client || !window.matchMedia) return 'hover'
            const isMobileMode = window.matchMedia('(hover: none), (pointer: coarse)').matches
            return isMobileMode ? 'click' : 'hover'
        },
    }


}
